export const Environments = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production"
};
